import React from "react";
import * as S from "./styled";
import { TSizeVariant, TColorVariant } from "./types";

type TProps = Omit<React.ComponentProps<typeof S.FeaturedIcon>, "$size" | "$color"> & {
    color?: TColorVariant;
    size?: TSizeVariant;
};

const FeaturedIcon: React.FC<TProps> = ({ size = "md", color = "primary", ...props }) => {
    return <S.FeaturedIcon $size={size} $color={color} {...props} />;
};

export default FeaturedIcon;
